import React, { useContext, useMemo } from 'react';
import styled from 'styled-components';
import { Box, Card, Grid, Typography } from '@material-ui/core';

import CardContent from '../../common/card/CardContent';
import PageTemplate from '../../common/page-template/PageTemplate';
import PageTemplateDashboard from '../../common/page-template/PageTemplateDashboard';
import PageTemplateHeader from '../../common/page-template/PageTemplateHeader';
import TrainingChartCard from './cards/TrainingChartCard';
import TrainingLogCard from './cards/TrainingLogCard';
import TrainingUpcomingCard from './cards/TrainingUpcomingCard';
import { UserContext } from '../../user/User.context';
import { useGetUserTrainingStats } from '../../user/User.hooks';

const StyledGrid = styled(Grid)`
  height: 100%;
  flex-flow: column;
  margin-top: unset;
  .MuiGrid-item {
    &:not(:last-child) {
      padding-top: unset;
    }
    &:last-child {
      padding-bottom: unset;
    }

    .MuiCard-root,
    .MuiCardContent-root {
      height: 100%;
    }

    /* center card content */
    .MuiCardContent-root {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;

export const formatter: Intl.NumberFormat = new Intl.NumberFormat(undefined, {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2
});

const TrainingPage: React.FC = () => {
  return (
    <PageTemplate>
      <PageTemplateHeader>
        <h2>Training Dashboard</h2>
      </PageTemplateHeader>
      <PageTemplateDashboard>
        <TrainingPageContent />
      </PageTemplateDashboard>
    </PageTemplate>
  );
};

export default TrainingPage;

export const TrainingPageContent: React.FC = () => {
  const defaultProgress: string = 'N/A';
  const userContext = useContext(UserContext);
  const { user } = userContext;
  const { data } = useGetUserTrainingStats(true, user?.id);

  const progress: string = useMemo(() => {
    let percent: number | undefined;
    if (data) {
      const total: number =
        data.completedCount + data.inProgressCount + data.toDoCount;
      percent = (data.completedCount / total) * 100;
    }
    return typeof percent === 'number' && isFinite(percent)
      ? formatter.format(percent) + '%'
      : defaultProgress;
  }, [data]);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={12} xl={8}>
                {/* Training Pie Chart */}
                <TrainingChartCard
                  middleText={
                    progress === defaultProgress ? undefined : progress
                  }
                />
              </Grid>
              <Grid item xs={12} xl={4}>
                <StyledGrid container spacing={3}>
                  <Grid item xs={12}>
                    <Card>
                      <CardContent>
                        <Box textAlign='center' m={2}>
                          <Typography variant='h4'>{progress}</Typography>
                          <Typography variant='overline'>
                            Overall Progress
                          </Typography>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                  <Grid item xs={12}>
                    {user && <TrainingUpcomingCard user={user} />}
                  </Grid>
                </StyledGrid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            {/* Training */}
            <TrainingLogCard />
          </Grid>
        </Grid>
      </Grid>
      {/* <Grid item xs={12} md={4}>
        <TrainingToDoCard />
      </Grid> */}
    </Grid>
  );
};
